import { render, staticRenderFns } from "./BlockListDocumentListCustom.vue?vue&type=template&id=31a7eee2&"
import script from "./BlockListDocumentListCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListDocumentListCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports